export const FEATURE_NAME = '@zerops/zui/process-item';

export enum ProcessItemModes {
  Project = 'project',
  Stack = 'stack',
  Full = 'full'
}
